module.exports = __webpack_public_path__ + "static/media/cases_web_keslon_06a.e773b40d.jpg";